const projects = [
  {
    id: 1,
    name: "Gigpit",
    slug: "gigpit",
    role: "UX/UI Design & UI Implementation",
    imageSource: "/images/gigpit/hero.webp",
  },
  {
    id: 2,
    name: "Fit52",
    slug: "fit52",
    role: "Engineering & UX/UI Design",
    imageSource: "/images/fit52/hero.webp",
  },

  {
    id: 3,
    name: "Crewlywed",
    slug: "crewlywed",
    role: "Engineering & Design",
    imageSource: "/images/crewlywed/hero.webp",
  },
];

export default projects;
